import { AvailableLanguages } from './available-languages';

export const supportedLanguages = [AvailableLanguages.en_GB, AvailableLanguages.en_US, AvailableLanguages.de];
